export const errorCodes = {
  2001: "Encryption value is invalid",
  2002: "Requested user is not registered",
  2003: "Please Provide all Mandatory parameters",
  2004: "Please provide a valid Agent code",
  2006: "Please provide a valid POP Registration number",
  2007: "Please provide a valid POP-SP Registration number",
  2008: "Please provide a valid JSON details",
  8900: "Agent Name should not be blank",
  8901: "Agent Name should not exceed 90 characters",
  8902: "Invalid Agent Name",
  8903: "PAN already exists",
  8904: "PAN should not be blank",
  8905: "Invalid PAN Number",
  8906: "ARN number should be 8 digit numeric value",
  8907: "Invalid ARN number",
  8908: "Email ID should not be blank",
  8909: "Invalid Email ID",
  8910: "Mobile number should not be blank",
  8911: "Invalid Mobile number",
  8913: "Registered Address should not exceed 50 length",
  8915: "Registered Address City should not exceed 50 length",
  8917: "Invalid Registered Address State",
  8919: "Invalid Registered Address Pincode",
  8920: "Correspondence Address should not be blank",
  8921: "Correspondence Address should not exceed 50 length",
  8922: "Correspondence Address City should not be blank",
  8923: "Correspondence  Address City should not exceed 50 length",
  8924: "Correspondence  Address State should not be blank",
  8925: "Invalid Correspondence  Address State",
  8926: "Correspondence Address Pincode should not be blank",
  8927: "Invalid Correspondence Address Pincode",
  8928: "Bank account number should not be blank",
  8929: "Bank account number should not exceed 20 length",
  8930: "Bank account number should not be less than 6 length",
  8931: "Invalid Bank account number",
  8932: "Bank IFSC code should not be blank",
  8933: "Invalid Bank IFSC code",
  8934: "Bank Name should not be blank",
  8935: "Bank Name should not exceed 50 length",
  8936: "Invalid Bank Name",
  8937: "Bank Branch should not be blank",
  8938: "Bank Branch should not exceed 50 length",
  8939: "Bank Address should not be blank",
  8940: "Bank Address should not exceed 50 length",
  8941: "Document Type should not be blank",
  8942: "Invalid Document Type",
  8943: "Document Name should not be blank",
  8944: "Invalid Document Name",
  8945: "PAN Document size should be between 2 KB and 5 MB",
  8946: "Cancel cheque Document size should be between 2 KB and 5 MB",
  8947: "Registered Address Proof Document size should be between 2 KB and 5 MB",
  8948: "Correspondence Address Proof Document size should be between 2 KB and 5 MB",
  8949: "Agreement Document size should be between 2 KB and 5 MB",
  8950: "Invalid Document size",
  8951: "Number of documents are less than the required number of documents",
  8952: "POP code should not blank",
  8953: "Invalid POP code",
  8954: "POP SP code should not blank",
  8955: "Invalid POP SP code",
  8956: "POP SP code does not belongs to provided POP code",
  8960: "No of customers should be numeric",
  8959: "Invalid years of experience",
  8961: "As per PFRDA, Only Individual PAN holders can be NPS Agents",
};
